import { rewriteAdminModulePath } from './rewrite-admin-module-path.js'

export function namespaceModuleSpecifiers(content: string, namespace: string): string {
  const replaceModulePath = (_match: string, prefix: string, modulePath: string, suffix: string) =>
    `${prefix}${rewriteAdminModulePath(modulePath, namespace)}${suffix}`

  return content
    .replace(
      /^(\s*(?:(?:import|export)\b[^\n]*\bfrom\s+|\}\s+from\s+)['"])(@admin(?:\/[^'"]*)?)(['"])/gm,
      replaceModulePath
    )
    .replace(/^(\s*import\s+['"])(@admin(?:\/[^'"]*)?)(['"])/gm, replaceModulePath)
}
